var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-button',{staticClass:"btn btn-primary w-75",staticStyle:{"max-width":"350px"},on:{"click":_vm.openConfirmSaveAssignmentsModal}},[_vm._v(" Save Selected Assignments to Ptrac ")])}
var staticRenderFns = []

export { render, staticRenderFns }